import { OneAnalyticsDashboardCategoryEnum } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

type DashboardConfig = {
  items?: unknown
}

export type OneAnalyticsSavedExplorationOpenSource = 'one_dashboard_action' | 'dashboards_list'

type DashboardTelemetryProperties = {
  dashboard_id?: string
  category: OneAnalyticsDashboardCategoryEnum
  item_count: number
  table_widget_count: number
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const getDashboardItemCounts = (config: DashboardConfig) => {
  const items = Array.isArray(config.items) ? config.items : []

  return {
    itemCount: items.length,
    tableWidgetCount: items.filter((item) => isRecord(item) && item.type === 'collection').length,
  }
}

export const trackOneAnalyticsExplorationSaved = ({
  config,
  dashboardId,
  category,
  saveKind,
}: {
  config: DashboardConfig
  dashboardId?: string
  category: OneAnalyticsDashboardCategoryEnum
  saveKind: 'create' | 'update'
}) => {
  const { itemCount, tableWidgetCount } = getDashboardItemCounts(config)

  track(trackingEvents.aiAnalytics.oneAnalyticsExplorationSaved, {
    dashboard_id: dashboardId,
    category,
    save_kind: saveKind,
    item_count: itemCount,
    table_widget_count: tableWidgetCount,
  })
}

export const trackOneAnalyticsSavedExplorationOpened = ({
  config,
  dashboardId,
  category,
  openedFrom,
}: {
  config: DashboardConfig
  dashboardId?: string
  category: OneAnalyticsDashboardCategoryEnum
  openedFrom: OneAnalyticsSavedExplorationOpenSource
}) => {
  const { itemCount, tableWidgetCount } = getDashboardItemCounts(config)
  const properties: DashboardTelemetryProperties & { opened_from: string } = {
    dashboard_id: dashboardId,
    category,
    opened_from: openedFrom,
    item_count: itemCount,
    table_widget_count: tableWidgetCount,
  }

  track(trackingEvents.aiAnalytics.oneAnalyticsSavedExplorationOpened, properties)
}
